import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { Loader } from 'core/elements';
import { SelectionCountProvider } from 'core/states';
import { CustomerQuotePartList, VendorQuotePartList } from 'quotes/components';
import { QuoteType } from 'quotes/enums';
import { QuoteHelper } from 'quotes/helpers';
import { useGetQuote } from 'quotes/hooks';
import { CustomerQuotePartsProvider } from 'quotes/states';
import { SelectedQuotePartProvider } from 'quotes/states/selectedQuotePart';
import { IVendorQuote } from 'quotes/types';
import { getQuoteVersion } from 'quotes/utils';

const QuotePartsPage = () => {
  const { quoteId } = useParams();

  const { t } = useTranslation();

  const { user } = useAuthUser();
  const { record, extraData, isLoading, isError } = useGetQuote({ quoteId });

  const quoteType = useMemo(
    () => QuoteHelper.determineType(record, user?.companyId),
    [record, user]
  );

  const initialQuoteVersion = getQuoteVersion(record);

  return (
    <PageLayout title={t('titleQuoteParts', { quoteId })} hasSwitchVersion>
      {isLoading && <Loader />}

      {isError && <Error statusCode={StatusCode.NOT_FOUND} />}

      <SelectionCountProvider>
        <SelectedQuotePartProvider>
          {QuoteType.CUSTOMER === quoteType && (
            <CustomerQuotePartsProvider initialQuoteVersion={initialQuoteVersion}>
              <CustomerQuotePartList initialQuote={record} extraQuoteData={extraData} />
            </CustomerQuotePartsProvider>
          )}

          {QuoteType.VENDOR === quoteType && <VendorQuotePartList quote={record as IVendorQuote} />}
        </SelectedQuotePartProvider>
      </SelectionCountProvider>
    </PageLayout>
  );
};

export default QuotePartsPage;
